import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

class ShareLocationComponent extends BridgeComponent {
    static component = "location";

    connect() {
        try {
            super.connect();

            if (!this.boundClickHandler) {
                this.boundClickHandler = this.shareLocation.bind(this);
                this.element.addEventListener("click", this.boundClickHandler);
            }
            // Native sends back coordinates directly here
            this.send("addLocationButton", {}, (response) => {
                document.body.classList.add("wkfashion-loading");

                this.handleLocationResponse(response);
            });
        } catch (err) {
            console.error("BridgeComponent connect error:", err);
        }
    }

    disconnect() {
        if (this.boundClickHandler) {
            this.element.removeEventListener("click", this.boundClickHandler);
            this.boundClickHandler = null;
        }
    }

    shareLocation() {
        window.triggerToast(
            "📍 Native location already fetched on connect. Click action does nothing now.",
            "info",
        );
    }

    handleLocationResponse(response) {
        const coords = wkhw_customForm.is_android
            ? response.data
            : response.data?.coordinates;
        if (!coords || coords.latitude == null || coords.longitude == null) {
            window.triggerToast("Could not fetch location.", "error");
            return;
        }

        const { latitude, longitude } = coords;

        document.body.classList.add("wkfashion-loading");
        const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`;

        fetch(url)
            .then((res) => res.json())
            .then((data) => {
                const address = data?.address || {};
                const city =
                    address.city || address.town || address.village || "";
                const state = data["ISO3166-2-lvl4;"] || address.state || "";
                const postcode = address.postcode || "";
                const countryCode = (address.country_code || "").toUpperCase();
                const streetAddress = data.display_name || undefined;

                const autofillAddress = (prefix) => {
                    const address1 = document.querySelector(
                        `#${prefix}_address_1`,
                    );
                    const cityField = document.querySelector(`#${prefix}_city`);
                    const postcodeField = document.querySelector(
                        `#${prefix}_postcode`,
                    );
                    const countryField = document.querySelector(
                        `#${prefix}_country`,
                    );
                    const stateField = document.querySelector(
                        `#${prefix}_state`,
                    );

                    if (address1) address1.value = streetAddress || city;
                    if (cityField) cityField.value = city;
                    if (postcodeField) postcodeField.value = postcode;

                    if (countryField) {
                        countryField.value = countryCode;
                        countryField.dispatchEvent(
                            new Event("change", { bubbles: true }),
                        );
                    }

                    setTimeout(() => {
                        if (stateField) {
                            const matchedOption = [...stateField.options].find(
                                (option) =>
                                    option.text
                                        .toLowerCase()
                                        .includes(state.toLowerCase()),
                            );
                            if (matchedOption) {
                                stateField.value = matchedOption.value;
                                stateField.dispatchEvent(new Event("change"));
                            }
                        }
                    }, 500);
                };

                autofillAddress("billing");
                autofillAddress("shipping");

                window.triggerToast(
                    "Address autofilled for billing and shipping.",
                    "success",
                );
                document.body.classList.remove("wkfashion-loading");
            })
            .catch((err) => {
                console.error("Reverse geocoding error:", err);
                window.triggerToast(
                    "Could not reverse geocode the location.",
                    "error",
                );
                document.body.classList.remove("wkfashion-loading");
            });
    }
}
export default ShareLocationComponent;
